module.exports = __webpack_public_path__ + "img/mobile-product.84fba572.png";